import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import { useSelector } from 'store/hooks';
import DonutCard from 'components/DashboardComponents/DashboardGraphs/DonutChartDashboard';
import DashboardListTable from 'components/DashboardComponents/DashboardListTable/DashboardListTable';
import PendingAtBarChart from 'components/DashboardComponents/DashboardGraphs/PendingAtBarChart';
import KpiMetricsTable from './KpiMetricsTable/KpiMetricsTable';
import AverageGradeCard from 'components/DashboardComponents/DashboardListTable/AverageGradeCard';
import { GridSortModel } from '@mui/x-data-grid-pro';

type KpiMetricsPerformanceProps = {
  donutDataClient: any;
  COLORS_CONSULTANT: string[];
  COLORS_DM: string[];
  COLORS_CLIENT: string[];
  barChartData: any;
  metric: any;
  data_table: any;
  onDownloadXlsx?: () => void;
  showDownload?: boolean;
};

const KpiMetricsPerformance = ({
  donutDataClient,
  COLORS_CONSULTANT,
  COLORS_DM,
  COLORS_CLIENT,
  barChartData,
  metric,
  data_table,
  onDownloadXlsx,
  showDownload,
}: KpiMetricsPerformanceProps) => {
  const { loadings } = useSelector((state) => state);
  const [sortModel, setSortModel] = React.useState<GridSortModel>([]);
  const workFlowLabels = [
    { labelname: '0', color: '#FF6040', dataKey: 'rating0', toolbarText: 'rating0Raw' },
    { labelname: '1', color: '#808080', dataKey: 'rating1', toolbarText: 'rating1Raw' },
    { labelname: '2', color: '#FF9100', dataKey: 'rating2', toolbarText: 'rating2Raw' },
    { labelname: '3', color: '#FFD200', dataKey: 'rating3', toolbarText: 'rating3Raw' },
    { labelname: '4', color: '#3C83F0', dataKey: 'rating4', toolbarText: 'rating4Raw' },
    { labelname: '5', color: '#60C39B', dataKey: 'rating5', toolbarText: 'rating5Raw' },
    { labelname: 'S', color: '#E600E6', dataKey: 'ratingS', toolbarText: 'ratingSRaw' },
  ];

  return (
    <>
      {/* Donut Chart Row */}
      <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }}>
        {[
          // { title: 'Consultant Submission', data: donutDataConsultant, colors: COLORS_CONSULTANT },
          // { title: 'DM Validation', data: donutDataDM, colors: COLORS_DM },
          { title: 'Rating', data: donutDataClient, colors: COLORS_CLIENT },
        ].map((item) => (
          //         <Grid container spacing={2}>
          // {items.map((item) => (
          <React.Fragment key={item.title}>
            {/* 1. Donut Chart Card */}
            <Grid item xs={12} sm={6} md={4} key={item.title}>
              <Paper
                sx={{
                  height: '284px',
                  flexGrow: 1,
                  flexBasis: 0,
                  borderRadius: 2,
                  p: 2,
                  boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <DonutCard
                  title={item.title}
                  data={Object.entries(item?.data ?? {}).map(([name, value]) => ({ name, value: value as number }))}
                  colors={item.colors}
                  chartHeight={180}
                />
              </Paper>
            </Grid>

            {/* 2. First Table Card */}
            <Grid item xs={12} sm={6} md={4}>
              <DashboardListTable
                data={Object.entries(item?.data ?? {})
                  .map(([name, value]) => {
                    const cleanedName = name.replace(/client/gi, '').trim();
                    const formattedName = cleanedName
                      ? cleanedName.charAt(0).toUpperCase() + cleanedName.slice(1).toLowerCase()
                      : cleanedName;
                    return { name: formattedName, value: value as number };
                  })
                  .sort((a, b) => a.name.localeCompare(b.name))}
                metric={metric}
              />
            </Grid>

            {/* 3. Second Table Card */}
            <Grid item xs={12} sm={6} md={4}>
              <AverageGradeCard data={item?.data ?? {}} />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>

      {/* Pending at Bar Chart */}
      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              boxShadow: '0px 3px 16px rgba(0, 0, 0, 0.15)',
              borderRadius: 2,
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
            }}
          >
            <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 600, mb: 1 }}>
              Rating
            </Typography>
            <PendingAtBarChart data={barChartData} height={250} baseLabels={workFlowLabels} />
          </Paper>
        </Grid>
      </Grid>
      {/* Table Row */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, borderRadius: 3 }}>
            {/* <KpiMetricsTable FilterKpiMetric={metric} dashboardKpiGridData={[]} FilterNeeded={false} /> */}
            <KpiMetricsTable
              FilterKpiMetric={metric}
              dashboardKpiGridData={data_table}
              FilterNeeded={false}
              isLoading={Boolean(loadings?.dashboardKpiGrid)}
              onDownloadXlsx={onDownloadXlsx}
              showDownload={showDownload}
              sortModel={sortModel}
              setSortModel={setSortModel}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default KpiMetricsPerformance;
